import styled from "styled-components";
import Modal from "./Modal";
import { BtnGeneral } from "../../styles/Buttons";

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmar accion",
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  confirmColor = "red",
  loading = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={loading ? undefined : onClose}
      title={title}
      width="520px"
      minH="auto"
      maxH="80vh"
      padding="20px"
      bodyOverflow="auto"
      closeOnOverlay={false}
      closeOnEsc={!loading}
    >
      <Content>
        <Message>{message}</Message>
        <Actions>
          <BtnGeneral
            as="button"
            type="button"
            bg="gray"
            padding="8px 16px"
            radius="6px"
            fw="600"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </BtnGeneral>
          <BtnGeneral
            as="button"
            type="button"
            bg={confirmColor}
            padding="8px 16px"
            radius="6px"
            fw="600"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Procesando..." : confirmText}
          </BtnGeneral>
        </Actions>
      </Content>
    </Modal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Message = styled.p`
  margin: 0;
  color: var(--color-text-body);
  line-height: 1.5;
  white-space: pre-wrap;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
